/* eslint-disable no-restricted-globals */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import RoomCacheProvider from './context/roomContext';
import PopupProvider from './context/popContext';
import { ZoomProvider } from "./telehealth/zoom/ZoomProvider";

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ZoomProvider>
      <PopupProvider>
        <RoomCacheProvider>
          <App />
        </RoomCacheProvider>
      </PopupProvider>
    </ZoomProvider>
  </React.StrictMode>
);

reportWebVitals();
